import React from 'react';

const awardsData = [
    {
        category: 'Best Player',
        player: 'John Doe',
        team: 'Eagles',
        profileImg: 'https://via.placeholder.com/50'
    },
    {
        category: 'Longest Drive',
        player: 'Jane Smith',
        team: 'Hawks',
        profileImg: 'https://via.placeholder.com/50',
        distance: '350 yards'
    },
    {
        category: 'Closest to the Pin',
        player: 'Mike Johnson',
        team: 'Falcons',
        profileImg: 'https://via.placeholder.com/50',
        distance: '5 inches'
    },
    {
        category: 'Best Team',
        player: 'Team Eagles',
        team: '',
        profileImg: 'https://via.placeholder.com/50'
    }
];

const Awards: React.FC = () => {
    return (
        <div className="container mx-auto p-4 bg-white">
            <h1 className="text-2xl font-bold mb-4">Golf League Awards</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {awardsData.map((award, index) => (
                    <div key={index} className="bg-white shadow-md rounded-lg p-4 flex items-center">
                        <img src={award.profileImg} alt={award.player} className="w-12 h-12 rounded-full mr-4" />
                        <div>
                            <h2 className="text-xl font-semibold">{award.category}</h2>
                            <p className="text-gray-700">{award.player}</p>
                            {award.team && <p className="text-gray-500">{award.team}</p>}
                            {award.distance && <p className="text-gray-500">{award.distance}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Awards;
